<template>
  <v-row v-if="data && getPrivilegesLevel(data) == 0" class="ma-0">
    <v-layout justify-center row wrap align-center :style="'height: ' + String(windowSize.y - 60 - 40) + 'px;'">
      <v-col cols="12" class="pa-0" align="center">
        <span class="error--text">⚠️ You are login as Admin. ⚠️</span>
        <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-col>
    </v-layout>
  </v-row>

    <v-row v-else-if="maintenance && maintenance.state" class="ma-0" align="center" justify="center">
      <v-col cols="5" align="center" class="pa-0">
        <v-layout row wrap align-center :style="'height: ' + String(windowSize.y - 60 - 40) + 'px;'">
          <v-card>
            <v-card-title class="teal title white--text"><v-spacer></v-spacer>メインテナンスのお知らせ<v-spacer></v-spacer></v-card-title>
            <v-card-text class="pa-2">
              <span style="white-space: pre-wrap;" class="subtitle-2">{{ maintenance.message }}</span>
            </v-card-text>
          </v-card>
        </v-layout>
    </v-col>
  </v-row>

  <v-row v-else-if="!user || shutdown" class="ma-0">
    <template v-if="checkServer()">
      <v-layout justify-center row wrap align-center class="overflow-y-auto" :style="'height: ' + String(windowSize.y - 60 - 40) + 'px;'">
        <v-col cols="12" class="pa-0" align="center">
        <!-- <v-col cols="12" class="pa-0 pb-10" align="center"> -->
          <v-img max-width="60%" :src="require('../assets/jv-title-logo.png')" class="my-4"></v-img>
          <!-- <v-img max-width="60%" :src="require('../assets/jv-title-logo.png')" class="my-4"></v-img> -->
          <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-col>
          <v-col cols="8" class="mx-auto py-0 select-none" align="start">
             <v-row class="mx-8">
               <v-col cols="6" align="center">
                 <v-card outlined class="pa-1 elevation-1" min-height="140">
                   <span class="primary--text title">ユーザ管理</span>
                   <v-card-subtitle class="pa-2">メールまたは Google™による認証をサポートし、講師〜室長〜塾長など権限に応じた管理が行えます。</v-card-subtitle>
                 </v-card>
               </v-col>
               <v-col cols="6" align="center">
                 <v-card outlined class="pa-1 elevation-1" min-height="140">
                   <span class="primary--text title">生徒管理</span>
                   <v-card-subtitle class="pa-2">保護者からの問い合わせ〜入会〜フォローアップ〜退会までの管理が簡単に行えます。</v-card-subtitle>
                 </v-card>
               </v-col>
               <v-col cols="6" align="center">
                 <v-card outlined class="pa-1 elevation-1" min-height="140">
                   <span class="primary--text title">チャット</span>
                   <v-card-subtitle class="pa-2">生徒情報の共有や資料、イベントの共有などが簡単に行えます。</v-card-subtitle>
                 </v-card>
               </v-col>
               <v-col cols="6" align="center">
                 <v-card outlined class="pa-1 elevation-1" min-height="140">
                   <span class="primary--text title">タスク管理</span>
                   <v-card-subtitle class="pa-2">イベント・タスクの管理が教室・ユーザ単位で簡単に行えます。</v-card-subtitle>
                 </v-card>
               </v-col>
               <v-col cols="6" align="center">
                 <v-card outlined class="pa-1 elevation-1" min-height="140">
                   <span class="primary--text title">情報共有</span>
                   <v-card-subtitle class="pa-2">Google™ Driveに保存されているファイルを簡単に共有することができます。</v-card-subtitle>
                 </v-card>
               </v-col>
               <v-col cols="6" align="center">
                 <v-card outlined class="pa-1 elevation-1" min-height="140">
                   <span class="primary--text title">経営管理</span>
                   <v-card-subtitle class="pa-2">在籍生徒情報の可視化、売上推移など、経営に必須の数値がリアルタイムで確認できます。</v-card-subtitle>
                 </v-card>
               </v-col>
             </v-row>
           </v-col>
           <v-col cols="8" class="mx-auto py-0" align="center">
             <v-card-text>
               <v-btn rounded outlined>本サービスは会員制サービスです。ご利用には<span @click="openLink('https://www.emr.ac/')" class="primary--text" style="cursor: pointer;">事前登録</span>が必要です。</v-btn>
             </v-card-text>
             <v-card-text>会員の方（利用者登録IDをお持ちの方）で、未登録の方は<span @click="$router.push('/signup')" class="primary--text" style="cursor: pointer;"> 新規登録 </span>から登録をお願いします。<br>会員の方（利用者登録IDをお持ちの方）で、登録済の方は<span  @click="$router.push('/signin')" class="primary--text" style="cursor: pointer;"> ログイン </span>からご利用いただけます。</v-card-text>
           </v-col>
      </v-layout>
    </template>
    <template v-else>
      <v-layout justify-center row wrap align-center :style="'height: ' + String(windowSize.y - 60 - 40) + 'px;'">
        <v-col cols="12" class="pa-0 pb-10" align="center">
          <v-img max-width="400px"
          :src="require('../assets/realte-logo.png')"
          ></v-img>
          <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-col>
      </v-layout>
    </template>
  </v-row>

  <v-row v-else-if="isUserNotRegistered && !loading && !prohibit && !shutdown" class="ma-0">
    <v-layout justify-center row wrap align-center :style="'height: ' + String(windowSize.y - 60 - 40) + 'px;'">
      <v-col cols="6" class="pa-0" align="center">
        <v-card>
          <v-card-title class="primary title white--text"><v-spacer></v-spacer>お客様のアカウントが新たに作成されました<v-spacer></v-spacer></v-card-title>
          <v-card-text class="pa-2">引き続き、お名前等、必要情報の登録へお進みください。「設定」ボタンを押下すると登録画面が開きます</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark depressed rounded color="primary" to="/setting">設定</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-layout>
  </v-row>

  <v-row  v-else-if="data && !prohibit && !shutdown" class="ma-0" align="center">
    <v-col cols="12" class="pa-0">
      <v-row class="ma-0 pa-0" align="center">
        <v-col cols="4" class="pa-1">
          <v-select
            class="pr-1"
            :items='tempGroups'
            label='教室'
            v-model='group3'
            item-text="name"
            item-value="key"
            hideDetails
            small-chips
            outlined
            dense
            :append-outer-icon="interlock == 'lock' ? 'mdi-link' : 'mdi-link-off'"
            @click:append-outer="onInterlocking()"
          ></v-select>
        </v-col>
        <v-col cols="8" class="pa-0 hidden-sm-and-down" align="end">
          <v-row align="center" class="ma-0 pa-0">
            <v-col cols="1" class="pa-0" align="center">
              <template>
                <v-btn depressed color="primary" @click="viewType = !viewType" class="ma-1 span">
                  <span v-if="viewType" class="caption font-weight-bold">数値</span>
                  <v-icon v-else small>mdi-chart-bar</v-icon>
                </v-btn>
              </template>
            </v-col>
            <v-col cols="3" class="pa-0" align="end">
              <v-select
                :items="$YEARS"
                label="年度"
                hideDetails
                v-model.number="year"
                class="pr-1"
                outlined
                dense
                item-text="name"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col cols="7" class="pa-0" align="center">
              <v-row class="ma-0" align="center" justify="center">
                <v-col cols="1" class="py-0 px-1" align="start">
                  <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="onREW()">
                    <v-icon>mdi-arrow-left-drop-circle-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="auto" class="pa-0" align="center">
                  <v-btn v-for="i in 12" icon x-small :key="i" class="ma-0 pa-0" depressed color="transparent" style="height: 25px; width: 25px;" @click="mm = i">
                    <v-avatar v-if="mm != i" size="20" tile class="primary--text caption" style="border: 1px solid #1565C0;">{{ $MONTH[i-1] }}</v-avatar>
                    <v-avatar v-else size="20" color="primary" tile class="white--text caption">{{ $MONTH[i-1] }}</v-avatar>
                  </v-btn>
                </v-col>
                <v-col cols="1" class="py-0 px-1" align="end">
                  <v-btn icon small color="transparent" class="ma-0 primary--text" depressed @click="onFF()">
                    <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="pa-0" align="start">
              <v-btn x-small rounded depressed color="primary" @click="thisMonth()"><span class="caption">当月</span></v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0" align="center">
        <v-col cols="12" class="pa-0" align="center">
          <v-card outlined>
            <v-card-text color="transparent" class="pa-0">
              <template v-if="viewType">
                <v-row class="ma-0 pa-1" align="center">
                  <v-col :cols="getPrivilegesLevel(data) < 3 ? 4 : 8" class="pa-0" align="center">
                    <v-sheet height="300" width="100%" color="transparent">
                      <app-metrics-main :view="false" :type="'bar'" :g="group3" :yyyy="year"></app-metrics-main>
                    </v-sheet>
                  </v-col>
                  <v-col v-if="getPrivilegesLevel(data) < 3" cols="4" class="pa-0" align="center">
                    <v-sheet height="300" width="100%" color="transparent">
                      <app-metrics-plan :view="false" :type="'graph'" :g="group3" :y="year"></app-metrics-plan>
                    </v-sheet>
                  </v-col>
                  <v-col cols="4" class="pa-0" align="center">
                    <v-sheet height="300" width="100%" color="transparent">
                      <app-metrics-main :view="false" :type="'pie'" :mm="mm" :g="group3" :yyyy="year"></app-metrics-main>
                    </v-sheet>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row class="ma-0 pa-1" align="center">
                  <v-col :cols="getPrivilegesLevel(data) < 3 ? 9 : 12" class="py-0 px-0">
                    <app-metrics-main :view="false" :type="'metric'" :mm="mm - 1" :g="group3" :yyyy="year"></app-metrics-main>
                  </v-col>
                  <v-col v-if="getPrivilegesLevel(data) < 3" cols="3" class="py-0 px-0">
                    <app-metrics-plan :view="false" :type="'metric'" :mm="mm - 1" :g="group3" :y="year"></app-metrics-plan>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-col v-if="checkPrivileges('plan')" cols="3" class="px-1 py-0">
      <v-card flat color="transparent">
        <v-card-text class='pa-0'>
          <v-col cols="12" class="pa-0">
            <v-toolbar color='primary' dark flat height="28" class="pa-0 ma-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="3" class="pa-0"></v-col>
                <v-col cols="6" class="pa-0" align="center">
                  <span class="select-none overflow-text-hidden">本日のタスク</span>
                </v-col>
                <v-col cols="3" class="pa-0" align="end">
                  <v-btn icon x-small @click="taskFilter = !taskFilter">
                    <v-icon small>{{ taskFilter ? 'mdi-tag' : 'mdi-school' }}</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click="dateSort = !dateSort">
                    <v-icon small>{{ dateSort ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-toolbar>
          </v-col>
          <v-col v-if="!taskFilter" cols="12" class="pa-0">
            <v-select
              class="mx-1 caption"
              dense
              :items='tempTaskGroups'
              v-model='group'
              hide-details
              item-text="name"
              item-value="key"
            ></v-select>
          </v-col>
          <v-col v-else cols="12" class="pa-0">
            <v-row class="ma-0" align="center" justify="center">
              <v-col cols="1" class="pa-0" align="end">
                <v-icon :color="getTagColor()" small>mdi-tag</v-icon>
              </v-col>
              <v-col cols="11" class="pa-0">
                <v-combobox
                  :items="tags"
                  v-model="tag"
                  item-text="name"
                  item-value="key"
                  hideDetails
                  dense
                  clearable
                  class="caption mx-1"
                ></v-combobox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pa-0">
            <app-schedule-main
              :param=" { type: 'home', group: group, taskFilter: taskFilter, tag: tag, viewType: viewType, dateSort: dateSort }">
            </app-schedule-main>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="3" class="px-1 py-0">
      <v-card flat color="transparent">
        <v-card-text class='pa-0'>
          <v-col cols="12" class="pa-0">
            <v-toolbar color='primary' dark flat height='28' class='pa-0'>
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0"></v-col>
                <v-col cols="10" class="pa-0" align="center">
                  <span class="select-none overflow-text-hidden">{{ actionStudents.length != 0 ? '要アクション生徒（' + actionStudents.length + '）' : '要アクション生徒'}}</span>
                </v-col>
                <v-col cols="1" class="pa-0" align="end">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small color="white">
                        <v-icon :color="menuAction.color" small>{{ menuAction.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <template v-for="(item, index) in menuActionItems">
                      <v-list-item
                        v-if="item.roles[getPrivilege(data)]"
                        :key="index"
                        @click="onMenuAction(item)"
                      >
                        <v-row class="ma-0" align="center">
                          <v-col cols="1" class="pa-0">
                            <v-icon :color="item.id == menuAction.id ? 'primary' : ' grey lighten-2'" small style="padding-bottom: 2px;">{{ item.icon }}</v-icon>
                          </v-col>
                           <v-col cols="11" class="py-0">
                             <span :class="item.id == menuAction.id ? 'pa-0 ma-0 secondary--text caption' : 'pa-0 ma-0 grey--text caption'">{{ item.title }}</span>
                           </v-col>
                        </v-row>
                      </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-toolbar>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-select
              class="mx-1 caption"
              dense
              :items='tempGroups'
              v-model='group1'
              hide-details
              item-text="name"
              item-value="key"
            ></v-select>
          </v-col>
          <v-col cols="12" class="pa-0">
            <div class='overflow-y-auto' :style="contentsHeight">
              <RecycleScroller
                class="scroller pa-1"
                :items="actionStudents"
                :item-size="54"
                key-field="key"
                v-slot="{ item }"
              >
                <v-card outlined height="50" @click.stop="onNewbie(item)">
                  <v-card-text class="pa-0">
                    <v-row class="ma-0 pa-1 customLine" align="center" justify="center">
                      <v-col cols="12" class="pa-0" align="center">
                        <v-row class="ma-0 pa-0" align="center">
                          <v-col cols="6" class="pa-0" align="start">
                            <v-row class="ma-0 pa-0" align="center">
                              <v-col v-if="school.studentsIcon" class="pa-0" align="center">
                                <img v-if="getProfileImage(item)" :src="getProfileImage(item)" height="20"/>
                                <v-icon v-else size="20">mdi-account-box</v-icon>
                              </v-col>
                              <v-col cols="10" class="pa-0">
                                <span class="ml-1 font-weight-bold" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;">{{ item.name != 'null' && item.name ? item.name : item.seiY + ' ' + item.meiY }}</span>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="6" class="pa-0" align="center">
                            <v-row class="ma-0 pa-0" align="center">
                              <template v-for="(action, ii) in item.actions">
                                <template v-if="action.ycs">
                                  <v-col cols="2" class="py-0" align="center" :key="ii + item.key + '_1'">
                                    <v-icon size="16" color="error">mdi-alert</v-icon>
                                  </v-col>
                                  <v-col cols="3" class="pa-0" align="center" :key="ii + item.key + '_1_1'">
                                    <p class="ycs">{{ getYCS(action.value) }}</p>
                                  </v-col>
                                </template>
                                <template v-if="action.dts">
                                  <v-col cols="2" class="pa-0" align="center" :key="ii + item.key + '_2'">
                                    <v-icon size="14" color="warning">mdi-phone</v-icon>
                                  </v-col>
                                  <v-col cols="4" class="pa-0" align="center" :key="ii + item.key + '_2_1'">
                                    <p class="dts warning--text">{{ action.span ? '' + '+' + action.span + '日' + '' : '未DTS' }}</p>
                                  </v-col>
                                </template>
                              </template>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="center">
                        <v-row class="ma-0 pa-0" align="center" justify="center">
                          <v-col cols="4" class="py-0 px-1" align="center">
                            <template v-if="item.action_birth">
                              <p color="primary" class="birth">{{ item.action_birth }}</p>
                            </template>
                          </v-col>
                          <v-col cols="4" class="py-0 px-1" align="center">
                            <template-group-avatar :item="item" :size="16" :height="16" ></template-group-avatar>
                          </v-col>
                          <v-col cols="4" class="py-0 px-1" align="center">
                            <p class="safe">{{ '在籍+' + item.action_days + '日' }}</p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </RecycleScroller>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col v-if="checkPrivileges('edit')" cols="3" class="px-1 py-0">
      <v-card flat color="transparent">
        <v-card-text class='pa-0'>
          <v-col cols="12" class="pa-0">
            <v-toolbar color='primary' dark flat height="28" class="pa-0 ma-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="1" class="pa-0">
                </v-col>
                <v-col cols="10" class="pa-0" align="center">
                  <span class="select-none overflow-text-hidden">{{ newStudents.length != 0 ? '新規生徒（' + newStudents.length + '）' : '新規生徒'}}</span>
                </v-col>
                <v-col cols="1" class="pa-0" align="end">
                  <v-btn icon small @click="onNewbie(null)"><v-icon>add_circle</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-toolbar>
          </v-col>
          <v-col cols="12" class="pa-0">
            <v-select
              class="mx-1 caption"
              dense
              :items='tempGroups'
              v-model='group2'
              hide-details
              item-text="name"
              item-value="key"
            ></v-select>
          </v-col>
          <v-col cols="12" class="pa-0">
            <div class='overflow-y-auto' :style="contentsHeight">
              <RecycleScroller
                class="scroller pa-1"
                :items="newStudents"
                :item-size="54"
                key-field="key"
                v-slot="{ item }"
              >
                <v-card outlined height="50" @click="onNewbie(item)">
                  <v-card-text class="pa-0">
                    <v-row class="ma-0 pa-1 customLine" align="center" justify="center">
                      <v-col cols="12" class="pa-0" align="start">
                        <v-row class="ma-0 pa-0" align="center">
                          <v-col cols="6" class="pa-0" align="start">
                            <v-row class="ma-0 pa-0" align="center">
                              <v-col v-if="school.studentsIcon" class="pa-0" align="center">
                                <img v-if="getProfileImage(item)" :src="getProfileImage(item)" height="20"/>
                                <v-icon v-else size="20">mdi-account-box</v-icon>
                              </v-col>
                              <v-col cols="10" class="pa-0">
                                <span class="ml-1 font-weight-bold" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;">{{ item.name != 'null' && item.name ? item.name : item.seiY + ' ' + item.meiY }}</span>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="2" class="py-0 px-1"></v-col>
                          <v-col cols="4" class="py-0 px-1" align="center">
                            <template-group-avatar :item="item" :size="16" :height="16" ></template-group-avatar>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="pa-0" align="center">
                        <v-row class="ma-0 pa-0" align="center">
                          <v-col cols="8" class="py-0 px-1" align="center">
                            <v-row class="ma-0 pa-0" align="center" justify="center">
                              <template v-if="item.status == $STATUS_LOSE">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="2" class="py-0 px-1" align="center">
                                    <v-icon size="14" color="error">sentiment_very_dissatisfied</v-icon>
                                  </v-col>
                                  <v-col cols="6" class="py-0 px-1" align="center">
                                    <p class="lose">{{ item.secession | moment }}</p>
                                  </v-col>
                                  <v-col cols="4" class="py-0 px-1"></v-col>
                                </v-row>
                              </template>
                              <template v-if="item.status < $STATUS_ADMISSION">
                                <v-icon small dark :color="item.status >= 1 ? 'success' : 'grey'">{{ 'mdi-numeric-1-circle' }}</v-icon>
                                <v-divider style="max-width:10%;"></v-divider>
                                <v-icon small dark :color="item.status >= 2 ? 'success' : 'grey'">{{ 'mdi-numeric-2-circle' }}</v-icon>
                                <v-divider style="max-width:10%;"></v-divider>
                                <v-icon small dark :color="item.status >= 3 ? 'success' : 'grey'">{{ 'mdi-numeric-3-circle' }}</v-icon>
                                <v-divider style="max-width:10%;"></v-divider>
                                <v-icon small dark :color="item.status >= 4 ? 'success' : 'grey'">{{ 'mdi-numeric-4-circle' }}</v-icon>
                                <v-divider style="max-width:10%;"></v-divider>
                                <v-icon small dark :color="item.status >= 5 ? 'success' : 'grey'">{{ 'mdi-numeric-5-circle' }}</v-icon>
                              </template>
                            </v-row>
                          </v-col>
                          <v-col v-if="item.status != $STATUS_LOSE" cols="4" class="py-0 px-1" align="center">
                            <v-row class="ma-0 pa-0" align="center">
                            <v-col cols="12" class="pa-0">
                              <p :class="checkOver(item) ? 'safe' : 'over'">{{ item.day + item.span + '日' }}</p>
                            </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </RecycleScroller>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="3" class="px-1 py-0">
      <v-card flat color="transparent">
        <v-card-text class='pa-0'>
          <v-col cols="12" class="pa-0" align="center">
            <v-toolbar color="warning" dark flat height='28' class='pa-0'>
              <v-spacer></v-spacer>
                  <span class="select-none overflow-text-hidden">お知らせ</span>
              <v-spacer></v-spacer>
            </v-toolbar>
            <div class='overflow-y-auto' :style="noticeHeight">
              <RecycleScroller
                class="scroller pa-1 ma-0"
                :items="myNotices"
                :item-size="36"
                key-field="key"
                v-slot="{ item }"
              >
                <v-card outlined @click="onClickNotice(item)">
                  <v-card-text class="pa-0">
                    <v-row class="ma-0 pa-1 customLine" align="center" justify="center">
                      <v-col cols="12" class="pa-0" align="start">
                        <v-tooltip bottom color="transparent">
                          <template v-slot:activator="{ on }">
                            <v-row v-on="on" class="ma-0 pa-0" align="center">
                              <v-col cols="1" class="pa-0">
                                <v-icon :color="getNoticeIconColor(item)" size="16">{{ getNoticeIcon(item) }}</v-icon>
                              </v-col>
                              <v-col cols="11" class="pa-0">
                                <p style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: auto;" class="notice caption">{{ item.title }}</p>
                              </v-col>
                            </v-row>
                          </template>
                          <v-card class="pa-0" width="200">
                            <v-card-text class="pa-1 caption">
                              <span>{{ '日付: ' + (item.date ? item.date : '') }}</span><br>
                              <span>{{ '概要: ' + (item.description ? item.description : '') }}</span>
                            </v-card-text>
                          </v-card>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </RecycleScroller>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>

    <div v-if="goalDialog">
      <v-dialog
        v-model="goalDialog"
        persistent
        width="400"
      >
        <template-policy
          :item="school"
          :type="'view'"
          @dismissed="onClose()">
        </template-policy>
      </v-dialog>
    </div>

    <div>
      <v-dialog v-model="studentDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-student-dialog
          v-if="studentDialog"
          @dismissed="onDismissed"
          :dialog='studentDialog'
          :item="item"
          :type="type"
        >
        </app-student-dialog>
      </v-dialog>
    </div>

    <div>
      <v-dialog
        v-model='noticeDialog'
        persistent
        max-width="400px">
        <app-notice-edit
          v-if="noticeDialog"
          @dismissed="onDismissed"
          :mode="'view'"
          :item="item"
          :dialog='noticeDialog'
        >
        </app-notice-edit>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import GoogleDrive from '../views/google/GoogleDrive.vue'
import ChartBar from '../components/charts/ChartBar.vue'
import ChartPie from '../components/charts/ChartPie.vue'
import ScheduleMain from './schedule/Main.vue'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
import NoticeEditDialog from '../components/notice/NoticeEditDialog'
import TemplatePolicy from '../components/school/TemplatePolicy.vue'
import MainActs from '../views/metrics/MainActs.vue'
import MetricsPlan from '../views/metrics/MetricsPlan.vue'
import TemplateGroupAvatar from '../components/common/TemplateGroupAvatar.vue'
import Graph from '../components/metrics/Graph.vue'

const moment = extendMoment(Moment)
Vue.component('app-google-drive', GoogleDrive)
Vue.component('chart-bar', ChartBar)
Vue.component('chart-pie', ChartPie)
Vue.component('app-schedule-main', ScheduleMain)
Vue.component('app-notice-edit', NoticeEditDialog)
Vue.component('template-policy', TemplatePolicy)
Vue.component('app-metrics-main', MainActs)
Vue.component('app-metrics-plan', MetricsPlan)
Vue.component('template-group-avatar', TemplateGroupAvatar)
Vue.component('template-metrics-graph', Graph)
export default {
  data () {
    return {
      mm: null,
      year: null,
      viewType: false,
      prohibit: false,
      noticeDialog: false,
      goalDialog: false,
      school: null,
      loading: false,
      tempGroups: [],
      tempTaskGroups: [],
      taskFilter: false,
      dateSort: true,
      group: [ '*' ],
      group1: [ '*' ],
      group2: [ '*' ],
      group3: [ '*' ],
      kpiGroup: ['*'],
      tempGoal: null,
      dialog: false,
      studentDialog: false,
      newbieType: null,
      title: 'title',
      message: 'message',
      text: '',
      item: null,
      show: true,
      menuSort: 'time',
      menuItems: [
        { title: '未実装', value: 'category' },
        { title: '未実装', value: 'time' }
      ],
      gData1: [],
      gData2: [],
      gData3: [],
      menuGraph: 'bar',
      menuGraphItems: [
        { title: '生徒推移', type: 'bar', id: 1, icon: 'mdi-chart-bar', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { title: '在籍割合', type: 'pie', id: 2, icon: 'mdi-chart-pie', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { title: '売上推移', type: 'bar', id: 3, icon: 'mdi-chart-bar', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      menuAction: null,
      menuActionItems: [
        { title: '全アクション', color: 'white', id: 0, icon: 'mdi-star', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { title: '誕生日', color: 'white', id: 1, icon: 'mdi-cake-variant', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { title: 'DTS', color: 'warning', id: 2, icon: 'mdi-phone', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } },
        { title: 'YCS', color: 'error', id: 3, icon: 'mdi-alert', roles: { admin: true, owner: true, chief: true, teacher: true, user: false } }
      ],
      interlock: 'unlock',
      tag: null,
      type: null
    }
  },
  computed: {
    ...mapGetters({
      initial: 'auth/initial',
      shutdown: 'auth/shutdown',
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      students: 'students/students',
      error: 'shared/error',
      privilege: 'shared/privilege',
      load: 'shared/loading',
      goal: 'shared/goal',
      notices: 'notices/notices',
      chatRefStatus: 'chatRefStatus/chatRef',
      tags: 'tags/tags',
      maintenance: 'shared/maintenance',
      windowSize: 'shared/windowSize',
      preschool: 'shared/preschool',
      extension: 'shared/extension'
    }),
    isUserNotRegistered () {
      if (this.user && this.users.length !== 0) {
        var index = this.users.findIndex(user => user.key === this.user.uid)
        if (index === -1) {
          return true
        }
        return !this.users[index].registered
      }
      return true
    },
    actionStudents () {
      var vm = this
      var students = JSON.parse(JSON.stringify(this.students))
      if (this.students.length === 0) {
        return []
      }
      var temp = students.filter(function (item, index) {
        var actions = []
        if (item.enable && item.status === vm.$STATUS_ADMISSION && vm.checkGroup(item, vm.group1)) {
          if (vm.school.actions.ycs) {
            if (item.tyg >= vm.school.actions.ycsLevel) {
              actions.push({
                ycs: true,
                date: item.admission,
                value: item.tyg
              })
            }
          }
          if (vm.school.actions.dts) {
            var value = vm.getLastDTS(item)
            if ((value != null && value.span > vm.school.actions.dtsSpan) || value === null) {
              actions.push({
                dts: true,
                date: value === null ? 'N/A' : value.date,
                span: value === null ? null : value.span
              })
              students[index]['dts_span'] = value === null ? 0 : value.span
            }
          }
          if (vm.school.actions.birth && moment(item.birth).isValid()) {
            var mm = ('00' + (moment(item.birth).month() + 1)).slice(-2)
            var dd = ('00' + moment(item.birth).date()).slice(-2)
            var dateTo = moment(String(moment().year()) + '-' + String(mm) + '-' + String(dd))
            var diff = moment().diff(dateTo, 'days')
            var ref = 0 - parseInt(vm.school.actions.birthSpan)
            if (diff >= ref && diff <= 0) {
              actions.push({
                birth: true,
                date: item.birth
              })
              students[index]['diff'] = diff
              students[index]['action_birth'] = item.birth
            }
          }
          students[index]['actions'] = actions
          var adm = moment(item.admission)
          diff = moment().diff(adm, 'days')
          students[index]['action_days'] = diff
          if (actions.length !== 0 && vm.checkAction(actions)) {
            return true
          }
          return false
        } else {
          return false
        }
      })
      temp.sort(function (a, b) {
        if (a.seiY > b.seiY) return 1
        if (a.seiY < b.seiY) return -1
        return 0
      })
      if (this.menuAction.id === 1) {
        temp.sort(function (a, b) {
          if (a.diff > b.diff) return -1
          if (a.diff < b.diff) return 1
          return 0
        })
      } else if (this.menuAction.id === 2) {
        temp.sort(function (a, b) {
          if (a.dts_span > b.dts_span) return -1
          if (a.dts_span < b.dts_span) return 1
          return 0
        })
      }
      return temp
    },
    newStudents () {
      var temp = []
      for (var i in this.students) {
        var student = JSON.parse(JSON.stringify(this.students[i]))
        if (student.enable && this.checkGroup(student, this.group2) && (student.status < this.$STATUS_ADMISSION || this.checkStatus(student))) {
          var index = student.events.findIndex(s => s.status === 1)
          if (index !== -1) {
            var day = moment(student.events[index].updatedAt)
            student['day'] = day.format('MM/DD +')
            student['span'] = moment().diff(day, 'days')
            temp.push(student)
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.span > b.span) return 1
        if (a.span < b.span) return -1
        return 0
      })
      return temp
    },
    myNotices () {
      var temp = []
      for (var i in this.notices) {
        if (this.notices[i].enable && (this.notices[i].schools['*'] || this.notices[i].schools[this.school.key])) {
          temp.push(JSON.parse(JSON.stringify(this.notices[i])))
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - (this.viewType ? 358 : 128) - 30 - 28 - 40) + 'px;'
    },
    noticeHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - (this.viewType ? 358 : 128) - 28 - 40) + 'px;'
    }
  },
  watch: {
    initial () {
      this.prohibit = false
      // if (this.school && this.school.popup && this.goal) {
      //   this.goalDialog = true
      // }
    },
    schools () {
      this.createGroups()
    },
    groups () {
      this.createGroups()
    },
    students () {
      if (this.studentDialog) {
        var index = this.students.findIndex(s => s.key === this.item.key)
        if (index !== -1) {
          this.item = JSON.parse(JSON.stringify(this.students[index]))
        }
      }
      this.createGroups()
    },
    data () {
      if (!this.isUserNotRegistered) {
        this.tempGoal = this.goal
      }
      this.createGroups()
    },
    load () {
      this.loading = this.load
    },
    group3 () {
      if (this.interlock === 'lock') {
        this.group1 = this.group2 = this.group = this.group3
      }
    }
  },
  created () {
    this.thisMonth()
    if (!this.initial) {
      this.prohibit = true
    }
    this.interlock = localStorage.interlock ? localStorage.interlock : 'lock'
    this.loading = this.load
    if (!window.gapi) {
      // console.warn('Google API not loaded')
      return
    }
    this.createGroups()
    this.onMenuGraph(this.menuGraphItems[0])
    this.onMenuAction(this.menuActionItems[0])
  },
  mounted () {
    if (this.school && this.school.popup && this.goal) {
      this.goalDialog = true
    }
  },
  methods: {
    openLink (url) {
      window.open(url, '_blank')
    },
    thisMonth () {
      moment.tz.setDefault('Asia/Tokyo')
      var mm = moment().month()
      if (mm > 2) {
        mm = mm - 2
      } else {
        mm = mm + 10
      }
      this.mm = mm
      this.year = this.getFY()
    },
    createGroups () {
      this.tempGroups = []
      if (!this.data) {
        return
      }
      if (this.getPrivilegesLevel(this.data) < 2) {
        this.tempGroups.push({ name: '全校', key: '*' })
      }

      this.school = this.getPrimary()

      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          if (typeof this.data.primaryGroup === 'undefined' || this.data.primaryGroup === null) {
            this.group = this.group1 = this.group2 = this.group3 = this.tempGroups[0].key
          } else {
            for (var x in this.tempGroups) {
              if (this.tempGroups[x].key === this.data.primaryGroup) {
                this.group = this.group1 = this.group2 = this.group3 = this.data.primaryGroup
                break
              }
            }
          }
        }
        this.tempTaskGroups = JSON.parse(JSON.stringify(this.tempGroups))
        index = this.chatRefStatus.findIndex(c => c.key === this.data.key)
        if (index !== -1) {
          keys = Object.keys(this.chatRefStatus[index].members)
          for (i in keys) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && !this.groups[index].classroom && this.groups[index].task) {
                this.tempTaskGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        }
      } else if (this.school !== null) {
        keys = Object.keys(this.school.groups)
        for (i in keys) {
          if (this.school.groups[keys[i]]) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          this.group = this.group1 = this.group2 = this.group3 = this.tempGroups[0].key
        }
        this.tempTaskGroups = JSON.parse(JSON.stringify(this.tempGroups))
        for (i in keys) {
          if (this.school.groups[keys[i]]) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && !this.groups[index].classroom && this.groups[index].task) {
                this.tempTaskGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        }
      }
    },
    getTagColor () {
      if (this.tag) {
        var index = this.tags.findIndex(t => t.key === this.tag.key)
        if (index !== -1) {
          return this.tags[index].color
        }
      }
      return 'grey'
    },
    getLastDTS (item) {
      var temp = null
      for (var i in item.events) {
        if (item.events[i].type === 1) {
          moment.tz.setDefault('Asia/Tokyo')
          var start = moment(item.events[i].date1)
          var end = moment(new Date())
          temp = {
            span: parseInt(end.diff(start, 'days')),
            date: item.events[i].date1
          }
          break
        }
      }
      return temp
    },
    getYCS (value) {
      var index = this.$YCSS.findIndex(y => y.key === value)
      if (index !== -1) {
        return this.$YCSS[index].name
      }
      return ''
    },
    checkValidGroup (key) {
      var ret = false
      for (var i in this.tempGroups) {
        if (this.tempGroups[i].key === key) {
          ret = true
          break
        }
      }
      return ret
    },
    checkOver (item) {
      var span = 7
      if (typeof this.school.newbee !== 'undefined') {
        span = this.school.newbee.span
      }
      return item.span < span
    },
    checkAction (actions) {
      var status = false
      if (this.menuAction.id === 0) {
        status = true
      } else if (this.menuAction.id === 1) {
        for (var i in actions) {
          if (actions[i].birth) {
            status = true
            break
          }
        }
      } else if (this.menuAction.id === 2) {
        for (i in actions) {
          if (actions[i].dts) {
            status = true
            break
          }
        }
      } else if (this.menuAction.id === 3) {
        for (i in actions) {
          if (actions[i].ycs) {
            status = true
            break
          }
        }
      }
      return status
    },
    checkGroup (item, group) {
      if (group === '*') {
        return true
      }
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        if (group === keys[i]) {
          return true
        }
      }
      return false
    },
    checkStatus (item) {
      moment.tz.setDefault('Asia/Tokyo')
      var start = moment(new Date())
      var end = moment(item.secession)
      var period = end.diff(start, 'days')
      return period > -7
    },
    getNoticeIconColor (item) {
      if (item.type) {
        var index = this.$NOTICE_TYPE.findIndex(notie => notie.key === item.type)
        return this.$NOTICE_TYPE[index].color
      }
    },
    getNoticeIcon (item) {
      if (item.type) {
        var index = this.$NOTICE_TYPE.findIndex(notie => notie.key === item.type)
        return this.$NOTICE_TYPE[index].icon
      }
    },
    getProfileImage (item) {
      if (item && item.avatar) {
        return item.avatar.thumbnail
      }
      return null
    },
    getAvatar (item) {
      var url = null
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].avatar) {
            return this.groups[index].avatar.thumbnail
          } else {
            break
          }
        }
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            name = this.groups[index].name.slice(0, 1)
          } else {
            break
          }
        }
      }
      return name
    },
    getGroupColor (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            return this.groups[index].color ? this.groups[index].color : 'primary'
          }
        }
      }
      return 'primary'
    },
    getCharge (item) {
      var index = this.users.findIndex(user => user.key === item.charge)
      if (index !== -1) {
        return JSON.parse(JSON.stringify(this.users[index].sei))
      }
      return ''
    },
    getChargeWidth (item, x) {
      // var height = '16px;'
      var font = '11px;'
      if (!item) {
        item = { category: '' }
        // height = '21px;'
        font = '12px;'
      }
      if (this.param === 'home') {
        // height = '18px;'
        font = '12px;'
      }
      var color = this.getDescriptionColor(item)
      var s = ''
      // s = 'width: 100%; ' + 'height: ' + height
      s += ' font-size: ' + font
      if (item.category !== '') {
        s += ' color: ' + color + '; background-color: #FFFFFF; border: 1px solid ' + color + ';'
      } else {
        s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      }
      return s
    },
    onREW () {
      if (this.mm === 1) {
        this.mm = 12
        this.year -= 1
      } else {
        this.mm -= 1
      }
    },
    onFF () {
      if (this.mm === 12) {
        this.mm = 1
        this.year += 1
      } else {
        this.mm += 1
      }
    },
    onInterlocking () {
      if (this.interlock === 'unlock') {
        this.interlock = 'lock'
      } else {
        this.interlock = 'unlock'
      }
      localStorage.interlock = this.interlock
    },
    onClickNotice (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.noticeDialog = true
    },
    onClose () {
      this.tempGoal = false
      this.goalDialog = false
      this.$store.dispatch('shared/setGoal', this.tempGoal)
    },
    onDismissed () {
      this.dialog = false
      this.studentDialog = false
      this.noticeDialog = false
      this.$store.dispatch('shared/setError', null)
    },
    onNewbie (item) {
      if (item === null) {
        this.item = JSON.parse(JSON.stringify(this.$store.getters['students/initial']))
        if (this.data) {
          if (this.data.primary) {
            this.item.schools[this.data.primary] = true
          } else {
            var keys = Object.keys(this.data.schools)
            for (var i in keys) {
              if (this.data.schools[keys[i]]) {
                this.item.schools[keys[i]] = true
                break
              }
            }
          }
          this.item.charge = this.data.key
        }
        this.type = 'new'
      } else {
        this.item = JSON.parse(JSON.stringify(item))
        this.type = this.checkPrivileges('edit') ? 'edit' : 'view'
      }
      this.studentDialog = true
    },
    onMenu (item) {
      this.menuSort = item.value
    },
    onMenuGraph (item) {
      this.menuGraph = item
    },
    onMenuAction (item) {
      this.menuAction = item
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style>
.b-B-GREY {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>

<style scoped>
img {
  object-fit: cover;
}

p {
  height: 16px;
  font-size: 11px !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid grey;
  margin: 2px;
  user-select: none;
}

p.notice {
  border: 0px;
  border-radius: 0px;
}

p.date {
  height: 16px;
  line-height: 16px;
  font-size: 10px !important;
  border-radius: 0px;
  border: 0px;
  padding: 0px !important;
  margin: 0px !important;
  border: 0px solid white;
}

p.ycs {
  height: 16px;
  line-height: 15px;
  font-size: 14px !important;
  border-radius: 8px;
  border: 0px;
  color: #FF5252;
  margin: 0px !important;
  padding-top: 2px !important;
}

p.dts {
  height: 14px;
  line-height: 14px;
  font-size: 12px !important;
  border-radius: 0px;
  border: 0px;
  padding: 0px !important;
  margin: 0px !important;
  vertical-align: middle !important;
}

p.birth {
  color: #0D47A1;
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  background-color: #BBDEFB;
  border: 1px solid #1976D2;
  text-align: center;
  width: 100%;
  height: 16px;
  font-size: 11px !important;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.lose {
  color: #B71C1C;
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  background-color: #FFCDD2;
  border: 1px solid #EF5350;
  text-align: center;
  width: 100%;
  height: 16px;
  font-size: 11px !important;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.group {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 8px;
  line-height: 16px;
  width: 100%;
  text-align: center;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.notice-date {
  height: 16px;
  font-size: 10px !important;
  border-radius: 8px;
  padding-left: 6px;
  border: 1px solid white;
  margin: 2px;
  color: black;
  background-color: white;
}

p.notice-due-date {
  height: 16px;
  font-size: 10px !important;
  border-radius: 8px;
  padding-left: 6px;
  border: 1px solid #4CAF50;
  margin: 2px;
  color: white;
  background-color: #4CAF50;

}

p.safe {
  color: black;
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  background-color: white;
  border: 1px solid black;
  text-align: center;
  width: 100%;
  height: 16px;
  font-size: 11px !important;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.over {
  color: #B71C1C;
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  background-color: #FFCDD2;
  border: 1px solid #EF5350;
  text-align: center;
  width: 100%;
  height: 16px;
  font-size: 11px !important;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

.scroller {
  height: 100%;
}

/* ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
} */

.v-btn.span {
  max-width: 14px !important;
  min-width: 14px !important;
  max-height: 32px !important;
}

.select-none {
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

</style>
